<template>
  <div id="app">
    <v-app>
      <component :is="layout">
      </component>
    </v-app>
  </div>
</template>

<script>
const defaultLayout = 'no-navigation';

export default {
  name: 'App',
  components: {
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || defaultLayout) + '-layout';
    }
  }
}
</script>

<style>
html {
    font-size:16px
}

@media screen and (min-width: 1440px) {
    html {
        font-size:18px
    }
}

@media screen and (min-width: 1920px) {
    html {
        font-size:20px
    }
}

body {
  line-height: 1.5;
  font-family: Open Sans, Helvetica Neue, Arial, Helvetica, sans-serif;
}

h1, h2, h3, h4, h5 {
    margin: 1.25rem 0 .5rem;
    line-height: 1.2;
    font-weight:400
}

h1 {
    font-size:2.5rem
}

h2 {
    font-size:2rem
}

h3 {
    font-size:1.5rem
}

h4 {
    font-size:1.25rem
}

h5 {
    font-size:1rem
}

.ht-site {
  display: flex;
  height: 100vh;
  flex-direction: column;
}

.ht-section-top-bar {
  flex-shrink: 0;
  background-color: #fff;
}

.ht-container {
  width: 100%;
  min-width: 280px;
  max-width: 1120px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px;
  padding-left: 2rem;
}

@media screen and (min-width: 640px) {
  .ht-container {
    padding:20px
  }
}

@media screen and (min-width: 1440px) {
  .ht-container {
    max-width:1280px
  }
}

@media screen and (min-width: 1920px) {
  .ht-container {
    max-width:1440px
  }
}

.ht-container-narrow {
  max-width:720px
}

@media screen and (min-width: 960px) {
  .ht-container-half {
    width:50%
  }
}

.ht-container:after {
  content: " ";
  display: table;
  clear: both;
}

.ht-container-admin {
  min-width: 0;
  max-width: none;
}

@media screen and (min-width: 960px) {
  .ht-container-admin {
    padding-right: 40px;
    padding-left:40px
  }
}

@media screen and (min-width: 1280px) {
  .ht-container-admin {
    padding-right: 60px;
    padding-left:60px
  }
}

@media screen and (min-width: 1440px) {
  .ht-container-admin {
    padding-right: 80px;
    padding-left:80px
  }
}

@media screen and (min-width: 1920px) {
  .ht-container-admin {
    padding-right: 120px;
    padding-left:120px
  }
}

.admin-nav {
  display: flex;
  flex-shrink: 0;
  flex-basis: auto;
  flex-direction: column;
  flex-grow: 0;
  width: 0;
  overflow-x: hidden;
  transition-property: width;
  transition-duration: .05s;
  transition-timing-function: ease-in-out;
  background-color: #45495b;
}

@media screen and (min-width: 640px) {
  .admin-nav {
    width: 220px;
  }

  .admin-nav.admin-nav-toggle {
    width: 0;
  }
}

@media screen and (min-width: 1280px) {
  .admin-nav {
    width: 320px;
  }

  .admin-nav.admin-nav--toggle {
    width: 0;
  }
}

@media screen and (min-width: 1440px) {
  .admin-nav {
    width: 380px;
  }

  .admin-nav.admin-nav-toggle {
    width: 0;
  }
}

@media screen and (min-width: 1920px) {
  .admin-nav {
    width: 440px;
  }

  .admin-nav.admin-nav-toggle {
    width: 0;
  }
}

.admin-nav-fixbox {
  display: flex;
  flex-grow: 1;
  width: 220;
}

@media screen and (min-width: 1280px) {
  .admin-nav-fixbox {
    width: 320px;
  }
}

@media screen and (min-width: 1440px) {
  .admin-nav-fixbox {
    width: 380px;
  }
}

@media screen and (min-width: 1920px) {
  .admin-nav-fixbox {
    width: 440px;
  }
}

.admin-nav-trigger {
  display: block;
  position: absolute;
  left: 0;
  top: 1.2rem;
  width: 2rem;
  /* height: 3.75rem; */
  background: transparent;
  border: none;
  text-align: center;
  cursor: pointer;
}

.admin-nav-trigger .admin-nav-trigger-icon {
  top: calc(50% - 1px);
  left: .5rem;
  /* width: .85rem;
  height: 2px; */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.admin-nav-trigger .admin-nav-trigger-icon, .admin-nav-trigger .admin-nav-trigger-icon:after, .admin-nav-trigger .admin-nav-trigger-icon:before {
  position: absolute;
  transition-property: transform, color;
  transition-duration: .15s;
  transition-timing-function: ease-in-out;
  color: #b6bacf;
}

.admin-nav-trigger .admin-nav-trigger-icon:after, .admin-nav-trigger .admin-nav-trigger-icon:before {
  left: 0;
  /* width: 100%;
  height: 100%; */
  content: "";
}

.admin-nav-trigger .admin-nav-trigger-icon:before {
  transform: translateY(-.3125rem);
}

.admin-nav-trigger .admin-nav-trigger-icon:after {
  transform: translateY(.3125rem);
}

.admin-nav-trigger:focus, .admin-nav-trigger:hover {
  outline: none;
}

.admin-nav-trigger:hover .admin-nav-trigger-icon, .admin-nav-trigger:hover .admin-nav-trigger-icon:after, .admin-nav-trigger:hover .admin-nav-trigger-icon:before {
  color: #191d2f;
}

.admin-footer {
  padding: 4rem .75rem .75rem 1rem;
  font-size: .64rem;
  letter-spacing: .05rem;
  color: #898d9f;
}

.admin-nav-icon {
  display: block;
  width: 100%;
  max-width: 2.5rem;
  max-height: 2.5rem;
  margin-left: auto;
  margin-right: auto;
  stroke: #a0a4b6;
}

.admin-panel {
  flex: 1 1;
  overflow-x: hidden;
  position: relative;
  background-color: #ecf1f9;
}

.admin-panel-fixbox {
  width: 100vw;
  overflow: hidden;
}

@media screen and (min-width: 640px) {
  .admin-panel-fixbox {
    width:auto
  }
}

.admin-page-header {
  background-color: #fff;
}

.admin-page-title > h2 {
  margin: 0;
  line-height: 1;
  font-size: 1.25rem;
  font-weight: 400;
  color: #5c6072;
}

.admin-content {
}

.admin-form {
}

.inner {
  position: relative;
  margin-bottom: 1rem;
  padding: 1rem;
  clear: both;
  background-color: #fff;
}

@media screen and (min-width: 1440px) {
  .inner {
    padding: 2rem;
  }
}

@media screen and (min-width: 1920px) {
  .inner {
    padding-left: 3rem;
    padding-right: 3rem;
  }
}

</style>
